//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/SelectFaceList.js";
import "../Routing/Routing.PathStockBuilder.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"FaceTrimMethod",1,0],[1,"Faces",0,"SelectFaceList",0],[0,"FirstPlane",1,"Plane",0],[0,"OverstockSettings",1,"Routing.PathStockBuilder",0],[1,"RoutingParts",0,"Assemblies.SelectComponentList",0],[0,"SecondPlane",1,"Plane",0],[0,"Type",1,0]],[],[]];
SPLM.Routing.FittingOverstockBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.FittingOverstockBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.FittingOverstockBuilder.Types = Object.freeze({
    "EntirePart" : "EntirePart", "EntireFace" : "EntireFace", "PartialFace" : "PartialFace"});

SPLM.Routing.FittingOverstockBuilder.TrimMethod = Object.freeze({
    "TrimPlane" : "TrimPlane", "BetweenPlanes" : "BetweenPlanes"});

export default SPLM;